import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { ISocial } from "../../../../types/models/social.models.types";
import type { IUser } from "../../../../types/models/user.models.types";

export interface IProposalSocial {
  proposalSocial: {
    id: string;
    addedByUser: IUser;
    fixedPayout: { amount: number; status: string } | null;
    fixedPayoutAmount: { amount: number; status: string } | null;
    commentCount: number;
    commentReadByUsersList: string[];
    createdAt: Date;
    updatedAt: Date;
  } | null;
  social: ISocial;
}

interface IResponse {
  campaignProposalSocials: Array<IProposalSocial>;
}

export function useGetProposalSocialsHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/proposals/:proposalId/socials",
  });
}
